import type { Option, OptionValue } from '@/components/Form/Select/Select';
import type { FieldOptions } from '@/hooks/useValidation';

export const NATIONALITY_OPTIONS: Option<OptionValue>[] = [
  {
    value: 'NL',
    label: 'Netherlands',
  },
  {
    value: 'BE',
    label: 'Belgium',
  },
  {
    value: 'DE',
    label: 'Germany',
  },
  {
    value: 'FR',
    label: 'France',
  },
] as const;

export const FELLOW_TRAVELER_FORM: Record<string, FieldOptions> = {
  callName: {
    label: 'Call name',
    type: 'string',
    required: true,
  },
  firstName: {
    label: 'Passport first name',
    type: 'string',
    required: true,
  },
  lastName: {
    label: 'Passport surname',
    type: 'string',
    required: true,
  },
  sex: {
    label: 'Gender',
    type: 'enum',
    required: true,
    choices: ['M', 'F'],
  },
  birthDate: {
    label: 'Date of birth',
    type: 'date',
    required: true,
  },
  birthPlace: {
    label: 'Place of birth',
    type: 'string',
    required: true,
  },
  nationality: {
    label: 'Nationality',
    type: 'enum',
    required: true,
    choices: NATIONALITY_OPTIONS.map((option) => option.value?.toString() || ''),
  },
  passportNumber: {
    label: 'Passport number',
    type: 'string',
    required: true,
  },
  passportIssueDate: {
    label: 'Passport issue date',
    type: 'date',
    required: true,
  },
  passportExpiryDate: {
    label: 'Passport expiry date',
    type: 'date',
    required: true,
  },
  mealPreference: {
    label: 'Dietary requirements',
    type: 'string',
  },
};

export const MAIN_BOOKER_FORM: Record<string, FieldOptions> = {
  ...FELLOW_TRAVELER_FORM,
  email: {
    label: 'Email',
    type: 'string',
    required: true,
  },
  phoneNumber: {
    label: 'Phone number',
    type: 'string',
    required: true,
  },
  zipCode: {
    label: 'Postcode',
    type: 'string',
    required: true,
  },
  houseNumber: {
    label: 'House number',
    type: 'string',
    required: true,
  },
  street: {
    label: 'Street name',
    type: 'string',
    required: true,
  },
  city: {
    label: 'Residence',
    type: 'string',
    required: true,
  },
  mainDriver: {
    label: 'Main driver',
    type: 'string',
  },
  remarks: {
    label: 'Comments',
    type: 'string',
  },
  emergencyContactName: {
    label: 'Home contact name',
    type: 'string',
  },
  emergencyContactPhoneNumber: {
    label: 'Home contact phone number',
    type: 'string',
  },
} as const;
